import { useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { useDialogFocus } from "@/hooks/useDialogFocus";
import "./quotation-management.css";

export function QuotationDeactivateConfirmation({
  open,
  title,
  description,
  pending,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  description: string;
  pending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const dialogRef = useRef<HTMLElement>(null);
  const close = () => {
    if (!pending) onClose();
  };
  useDialogFocus(dialogRef, close, { enabled: open });
  if (!open || typeof document === "undefined") return null;
  return createPortal(
    <div
      className="lnk-sheet-scrim lnk-management-modal-scrim is-open quotation-management-scrim"
      onClick={close}
    >
      <section
        ref={dialogRef}
        className="lnk-management-modal lnk-confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-label="Confirmar desativação"
        aria-describedby="quotation-deactivate-description"
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="lnk-modal-close lnk-confirm-close"
          aria-label="Fechar confirmação"
          disabled={pending}
          onClick={close}
        >
          <X size={19} />
        </button>
        <h2>{title}</h2>
        <p id="quotation-deactivate-description">{description}</p>
        <footer>
          <button type="button" disabled={pending} onClick={close}>
            Cancelar
          </button>
          <button
            type="button"
            className="lnk-confirm-danger"
            disabled={pending}
            onClick={onConfirm}
          >
            Desativar
          </button>
        </footer>
      </section>
    </div>,
    document.body,
  );
}
